import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'app-total-count-counter',
  templateUrl: './total-count-counter.component.html',
  styleUrls: ['./total-count-counter.component.scss'],
})
export class TotalCountCounterComponent implements OnInit {
  constructor() {}

  @Input() targetValue: number = 0 // 최종 목표 값
  @Input() textStyle: { [key: string]: string } = {}
  @Input() unit: 'user' | 'count' = 'user'
  displayedValue: number = 0 // 현재 표시되는 값

  ngOnInit() {
    this.animateCounter()
  }

  animateCounter() {
    const duration = 1500
    const steps = 60
    const interval = duration / steps
    const increment = this.targetValue / steps

    let currentValue = 0

    const timer = setInterval(() => {
      currentValue += increment
      this.displayedValue = Math.min(Math.round(currentValue), this.targetValue)

      if (currentValue >= this.targetValue) {
        clearInterval(timer)
      }
    }, interval)
  }
}
